import makeApiCall from "./master/axiosIndex";
export const ratecardApis = {
  createRatecard: (data: any): Promise<any> => {
    return makeApiCall({ url: "/ratecard/create", method: "post", data });
  },
  getRatecardDropdown: (): Promise<any> => {
    return makeApiCall({ url: "/ratecard/dropdown", method: "get" });
  },
  getRatecardList: (data: any): Promise<any> => {
    return makeApiCall({ url: "/ratecard/list", method: "get", params: data });
  },
  getRatecardById: (ratecardId: string): Promise<any> => {
    return makeApiCall({ url: `/ratecard/id/${ratecardId}`, method: "get" });
  },
  updateRatecard: (data: any): Promise<any> => {
    return makeApiCall({ url: "/ratecard/update", method: "put", data });
  },
  deactivateRatecard: (ratecardId: string): Promise<any> => {
    return makeApiCall({
      url: `/ratecard/deactivate/${ratecardId}`,
      method: "patch",
    });
  },
  activateRatecard: (ratecardId: string): Promise<any> => {
    return makeApiCall({
      url: `/ratecard/activate/${ratecardId}`,
      method: "patch",
    });
  },
};
